import { useEffect, useState } from 'react'

const DURATION_MS = 3 * 60 * 60 * 1000
const STORAGE_KEY = 'caligrafia-21-dias-deadline'

function resolveDeadline(): number {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY)
    if (stored) {
      const parsed = Number(stored)
      if (!Number.isNaN(parsed) && parsed > Date.now()) return parsed
    }
    const next = Date.now() + DURATION_MS
    window.localStorage.setItem(STORAGE_KEY, String(next))
    return next
  } catch {
    return Date.now() + DURATION_MS
  }
}

let deadline: number | null = null

function getDeadline(): number {
  if (deadline === null) deadline = resolveDeadline()
  return deadline
}

export interface CountdownValue {
  hours: string
  minutes: string
  seconds: string
}

function computeRemaining(): CountdownValue {
  const diff = Math.max(0, getDeadline() - Date.now())
  const totalSeconds = Math.floor(diff / 1000)
  const hours = Math.floor(totalSeconds / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = totalSeconds % 60
  const pad = (n: number) => String(n).padStart(2, '0')
  return { hours: pad(hours), minutes: pad(minutes), seconds: pad(seconds) }
}

export function useCountdown(): CountdownValue {
  const [value, setValue] = useState<CountdownValue>(() => computeRemaining())

  useEffect(() => {
    const id = window.setInterval(() => setValue(computeRemaining()), 1000)
    return () => window.clearInterval(id)
  }, [])

  return value
}
